export const organizationRoutes = [
    {
        name: "organization-contacts",
        path: "/ward/:wardId/organization/:organizationCode/contacts",
        component: () => import("@/app/organizations/OrganizationContacts"),
        props:true
    }
]
